import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useDispatch } from "react-redux";
import { resetTask } from "../../actions";
import ReusableButton from "../../components/general/ReusableButton";
import { TASK_MODE } from "./useTaskMode";

export default function Breadcrumbs({ mode }) {
  const dispatch = useDispatch();
  const isAdd = mode === TASK_MODE.ADD;

  return (
    <div className="firstRowContainer dashboardAndSelfBtnDiv">
      <ReusableButton
        text="Dashboard"
        fontSize={14}
        bgColor="#F16774"
        height={36}
        width={125}
        br={18}
        to="/dashboard"
        iconType="home"
      />
      <ChevronRightIcon />
      <ReusableButton
        text="Tasks"
        fontSize={14}
        bgColor="#F16774"
        height={36}
        br={18}
        {...(isAdd
          ? { onClick: () => dispatch(resetTask()) }
          : { to: "/task" })}
      />
    </div>
  );
}
